module.exports = __webpack_public_path__ + "img/itx-file-type-odg.a76adead.svg";